import { AuthLayoutTemplate, BrandContainerDefault } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import { useEffect } from 'react'
import { model as logoModel } from '~/features/logo'
import { authLayoutModel } from '~/widgets/auth'

interface Props {
  children: React.ReactNode
}

/**
 *  @todo: temporary solution while  new TOA layouts will not be ready
 */
TOALayout.displayName = 'TOALayout'
export function TOALayout({ children }: Props): JSX.Element | null {
  const { logoUrl, backgroundLoaded, backgroundUrl, logoHeight } = useUnit({
    logoUrl: logoModel.$logoUrl,
    backgroundLoaded: authLayoutModel.$backgroundLoaded,
    backgroundUrl: authLayoutModel.$authBackgroundUrl,
    logoHeight: logoModel.$logoHeight,
  })

  const { loadBackground } = useUnit({
    loadBackground: authLayoutModel.loadBackground,
  })

  useEffect(() => {
    loadBackground()
  }, [loadBackground])

  return (
    <AuthLayoutTemplate
      posterUrl={backgroundUrl}
      backgroundOpacity={backgroundLoaded ? 1 : 0}
      backgroundOpacityTransitionDuration={1}
    >
      <a href='/' style={{ zIndex: 11 }}>
        <BrandContainerDefault
          logoUrl={logoUrl}
          logoHeight={logoHeight || '60px'}
        />
      </a>
      {children}
    </AuthLayoutTemplate>
  )
}
